import { normalizarPatrimonio } from '../models/equipamento.utils';
import { TIPO_ATIVO_LABELS } from '../pages/EquipamentosListPage/components/Ativos/ativos.definitions';
import type { EquipamentoResumo } from '../services';

/**
 * Uma linha legível pro equipamento de um colaborador (ex.: lista "Quais equipamentos serão
 * devolvidos?"): tipo primeiro, depois o identificador e o que ajuda a reconhecer — modelo pros
 * equipamentos, linha/operadora pro chip. Sem isso, chip e cartão de acesso apareciam só
 * como um número ("9", "6142659").
 */
export function descreverEquipamentoResumo(equipamento: EquipamentoResumo): { tipo: string; detalhe: string } {
  const tipo = equipamento.tipo ? (TIPO_ATIVO_LABELS[equipamento.tipo] ?? equipamento.tipo) : 'Equipamento';
  const patrimonio = normalizarPatrimonio(equipamento.patrimonio);
  const extra =
    equipamento.tipo === 'chip'
      ? [equipamento.linha ? `linha ${equipamento.linha}` : null, equipamento.operadora]
      : [fabricanteEModelo(equipamento.fabricante, equipamento.modelo)];
  return { tipo, detalhe: [patrimonio, ...extra].filter(Boolean).join(' · ') || '—' };
}

/** "Lenovo" + "Lenovo - ideapad..." → só o modelo (o GLPI costuma repetir o fabricante no modelo). */
export function fabricanteEModelo(fabricante: string | null | undefined, modelo: string | null | undefined): string | null {
  const f = fabricante?.trim();
  const m = modelo?.trim();
  if (!m) return f || null;
  if (!f || m.toLowerCase().startsWith(f.toLowerCase())) return m;
  return `${f} ${m}`;
}
